import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiAlertModule } from '@snelstart/ui-alert';
import { SharedUiContextMenuModule } from '@snelstart/ui-context-menu';
import { SharedUiTooltipTriggerModule } from '@snelstart/ui-tooltip-trigger';
import { SharedUiTooltipModule } from '@snelstart/ui-tooltip';
import { SharedUiIconModule } from '@snelstart/ui-icon';
import {SharedUiButtonModule} from "@snelstart/ui-button";
import {SharedUiDialogModule} from "@snelstart/ui-dialog";
import {SharedUiTableModule} from "@snelstart/ui-table";
import {DomainLogicModule} from "@snelstart-ventures/fiscaal/domain-logic";
import {SharedUiPanelModule} from "@snelstart/ui-panel";
import {SharedUiBadgeModule} from "@snelstart/ui-badge";
import {FeatureTaxClientDetailsComponent} from "./tax-client-details/feature-tax-client-details.component";

@NgModule({
  imports: [
    CommonModule,
    SharedUiDetailsModule,
    SharedUiFormControlsModule,
    SharedUiAlertModule,
    SharedUiContextMenuModule,
    SharedUiTooltipTriggerModule,
    SharedUiTooltipModule,
    SharedUiIconModule,
    SharedUiButtonModule,
    SharedUiDialogModule,
    SharedUiTableModule,
    DomainLogicModule,
    SharedUiPanelModule,
    SharedUiBadgeModule,
  ],
  declarations: [],
  exports: [],
})
export class FeatureTaxClientDetailsModule {}
